<div class="header-title">
  <div class="flex u-align-items-center u-pa-20">
    <div class="flex flex-align-center">
      <a routerLink="/button" aria-label="back"
        class="u-button u-button--link u-button--back u-button-icon-left u-ma-0 u-button--auto" type="button">
        <span class="u-icon icon-chevron-left"></span>
        <span class="u-button-text">Back</span>
      </a>
    </div>
    <div class="page-title flex u-w-100 u-justify-content-center u-position-absolute u-position-left">
      <h1 class="font-semibold u-ma-0 flex header-title--name">Course level content card</h1>
    </div>
  </div>
  <div class="c-header__gradient"></div>
</div>

<div class="content">
  <maced-course-level-content-card id="courseLevelCardId" [imageUrl]="imageUrl" [imageAltName]="imageAltName" [enhancedCardWidth]="215" [enhancedCardHeight]="125"
    [title]="title" [subtitle]="subtitle" [startDate]="startDate" [endDate]="endDate" 
    [courseContentList]="courseContentList" [startDateLabel]="startDateLabel" [endDateLabel]="endDateLabel">
    <p class="c-course-level-card__body-content">Curabitur et purus quis tellus scelerisque faucibus ut ut justo. Mauris rhoncus ac metus in efficitur. Praesent finibus mi sit amet dolor porta consectetur. </p>
  </maced-course-level-content-card>
</div>

<div class="content">
  <maced-course-level-content-card id="courseLevelCardIdSpanish" [imageUrl]="imageUrlSpanish" 
    [imageAltName]="imageAltName" [title]="titleSpanish" [subtitle]="subtitleSpanish" [startDate]="startDateSpanish"
    [endDate]="endDateSpanish" [courseContentList]="courseContentListSpanish" [startDateLabel]="startDateLabelSpanish"
    [endDateLabel]="endDateLabelSpanish" [enhancedCardWidth]="215" [enhancedCardHeight]="125">
    <p class="c-course-level-card__body-content">Curabitur et purus quis tellus scelerisque faucibus ut ut justo. Mauris rhoncus ac metus in efficitur. Praesent finibus mi sit amet dolor porta consectetur. </p>
  </maced-course-level-content-card>
</div>

<div class="content">
  <maced-course-level-content-card id="courseLevelCardIdHindi" [imageUrl]="imageUrlHindi" [imageAltName]="imageAltName"
    [title]="titleHindi" [subtitle]="subtitleHindi" [startDate]="startDateHindi" [endDate]="endDateHindi" 
    [courseContentList]="courseContentListHindi" [startDateLabel]="startDateLabelHindi"
    [endDateLabel]="endDateLabelHindi" [enhancedCardWidth]="215" [enhancedCardHeight]="125">
    <p class="c-course-level-card__body-content">Curabitur et purus quis tellus scelerisque faucibus ut ut justo. Mauris rhoncus ac metus in efficitur. Praesent finibus mi sit amet dolor porta consectetur. </p>
  </maced-course-level-content-card>
</div>

<div class="content">
  <maced-course-level-content-card [id]="courseLevelCardWithLinkId" [imageUrl]="imageUrl" [imageAltName]="imageAltName"
  [title]="title2" [subtitle]="subtitle" [startDate]="startDate" [endDate]="endDate" 
    [courseContentList]="courseContentWithLinkList" [startDateLabel]="startDateLabel" [endDateLabel]="endDateLabel"
    [hasCardBody]="false" [hasCardFooter]="false" [enhancedCardWidth]="215" [enhancedCardHeight]="125">
    <p class="c-course-level-card__body-content">Curabitur et purus quis tellus scelerisque faucibus ut ut justo. Mauris rhoncus ac metus in efficitur. Praesent finibus mi sit amet dolor porta consectetur. </p>
  </maced-course-level-content-card>
</div>
<!-- New use case for builder -->
<div class="content">
  <h2>New use case for builder</h2>
  <div class="c-course-card c-course-card--builder">
    <maced-course-level-content-card id="courseLevelCardWithAccordian" [hasCustomisedCard]="true">
        <!-- New Course Book -->
        <ng-container ngProjectAs="[courseLevelContentCardHeader]">
          <maced-global-card cardId="sampleCard3" cardName="sampleCardName">
            <div class="c-course-card__header">
              <div class="c-course-card__header-left">
                <div class="c-course-card__header-left-image">
                  <img class="c-course-card__header-left-image-placeholder" src="../../assets/images/dummy-logo.jpg" [alt]="imageAltName" width="215" height="125">
                </div>
              </div>
              <div class="c-course-card__header-right">
                <header class="c-course-card__header-right-top" role="presentation">
                  <h2 class="c-course-card__header-right__title" *ngIf="title">
                    Macmillan English Campus (MEC)
                  </h2>
                  <p class="c-course-card__header-right__subtitle" *ngIf="subtitle">
                    All Levels
                  </p>
                </header>
                <div class="c-course-card__header-right-content">
                  <div class="c-course-card__header-right-content-details">
                    <span class="c-course-card__header-right-content-details-label">Start Date:</span>
                    <span class="c-course-card__header-right-content-details-input">12 Sep 2023</span>
                  </div>
                  <div class="c-course-card__header-right-content-details">
                    <span class="c-course-card__header-right-content-details-label">End Date:</span>
                    <span class="c-course-card__header-right-content-details-input">12 Jun 2024</span>
                  </div>
                </div>
              </div>
            </div>
          </maced-global-card>
        </ng-container>
        <!-- New Course List -->
        <ng-container ngProjectAs="[courseLevelContentCardBody]">
          <maced-global-card cardId="sampleCard1" cardName="sampleCardName1" >
            <div class="c-course-card__content">
            <a routerLink="/button" aria-label="back"
              class="u-button u-button--link u-button--back u-button-icon-left u-ma-0 u-button--auto c-course-card__content-back-button"
              type="button">
              <span class="u-icon icon-chevron-left"></span>
              <span class="u-button-text">Back</span>
            </a>
            <div class="c-course-card__content-list" role="list">
              <ng-container *ngFor="let courseContent of courseContentLisWithAccordiant">
                <div class="c-course-card__content-list-item" role="listitem">
                <maced-global-card  cardId="sampleCard2" cardName="sampleCardName1">
                  <div class="c-course-card__content-list-item-header">
                    <div class="c-course-card__content-list-item-header-image">
                      <img class="c-course-card__content-list-item-header-image-placeholder" src="../../assets/images/corse-list-demo-img.svg"
                        [alt]="imageAltName" width="94" height="94">
                    </div>
                    <div class="c-course-card__content-list-item-header-tag">
                      <maced-chip [chipId]="courseContent.chipId" [iconText]="iconText" [label]="courseContent.chipLable"
                        [status]="courseContent.chipStatus" [size]="selectedSize" [hasOutline]="hasOutline"
                        [disabled]="courseContent.chipState" [icon]="courseContent.chipIcon" [hasStatusIcon]="hasStatusIcon">
                      </maced-chip>
                    </div>
                  </div>
                  <div class="c-course-card__content-list-item-details">
                    <h3 class="c-course-card__content-list-item-title">{{courseContent.subTitle}}</h3>
                    <div class="c-course-card__content-list-item-accordion">
                      <maced-accordian accordianId="accordianId1" [collapseLabel]="collapseLabel" [expandLabel]="expandLabel"
                        [hasContentBelow]="hasContentBelow" [hasActions]="hasActions" [hasIconLeftSide]="hasIconLeftSide"
                        [hasDefaultExpanded]="hasDefaultExpanded" >
                        <p ngProjectAs="[accordionContent]" class="c-accordion__body">
                          Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia conseq duis
                          enim
                          velit
                          mollit. Exercitation veniam consequat sunt nostrud amet. Amet minim mollit non deserunt ullamco est
                          sit
                          aliqua
                          dolor do amet sint. Velit officia conseq duis enim velit mollit. Exercitation veniam consequat sunt
                          nostrud
                          amet.
                        </p>
                      </maced-accordian>
                    </div>
                  </div>
                  <div class="c-course-card__content-list-item-footer">
                    <maced-button type="link" buttonId="buttonId1" color="primary" label="View Details"></maced-button>
                  </div>
                </maced-global-card>
                </div>
              </ng-container>
            </div>
            </div>
          </maced-global-card>
        </ng-container>
    </maced-course-level-content-card>
  </div>  
</div>